// Admin / operations routes — AdminLayout shell, role-gated (doc 04 §8.2).
import type { RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    name: 'admin-dashboard',
    component: () => import('@/pages/admin/AdminDashboardPage.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      roles: ['super-admin', 'association-admin'],
      title: 'Admin',
    },
  },
]
